import React from 'react';

function TrackingSHeet() {
  return <div>TrackingSHeet</div>;
}

export default TrackingSHeet;
